/* eslint-disable no-unused-vars */
import { useEffect } from 'react';
import { Loader } from 'components';
import { LoginAppNextLogoSmall } from 'assets/icons';
import { authAPI } from 'services/newPlatformAuth.service';
import { showPolipop } from 'utils';
import * as S from './UserSignup.styled';

export const SubmitSuccessful = ({ data }) => {
  const [ResendUserSignUpEmailAction, result] = authAPI.useResendUserSignUpEmailMutation();

  function handleResend() {
    ResendUserSignUpEmailAction(data);
  }

  useEffect(() => {
    showPolipop(result);
  }, [result]);

  return (
    <S.SubmitSuccessfulBox>
      {result.isLoading && (
        <S.LoaderBox>
          <Loader.Local delay={100} />
        </S.LoaderBox>
      )}
      <LoginAppNextLogoSmall />
      <S.SuccessText>
        Please confirm your email address. We sent you a verification message to{' '}
        <b>{data.username}</b>
      </S.SuccessText>
      <S.Separator />
      <S.SuccessText>
        Haven’t recieved this email?{' '}
        <S.SuccessLink onClick={handleResend}>Resend Email</S.SuccessLink> or check your spam.
      </S.SuccessText>
    </S.SubmitSuccessfulBox>
  );
};
